<template>
	<div>
		<Popup
			v-model:show="userDetail"
			position="bottom"
			closeable
			:close-on-click-overlay="false"
			:style="{ height: '600px' }">
			<div style="font-size: var(--base-px-14);font-weight: bold;text-align: center;padding-top: var(--base-px-15);">
				客户资料详情
			</div>
			<Divider/>
			<div class="user_flex user_page" style="padding-bottom: var(--base-px-20);">
				<div style="display: flex;">
					<img :src="avatar" alt="" style="width: var(--base-px-50);height: var(--base-px-50);">
					<div style="margin-left: var(--base-px-10);font-size: var(--base-px-14)">
						<div style="font-size: var(--base-px-16);font-weight: bold;">{{ userName }}</div>
						<div style="color: #72C871;margin-top: var(--base-px-5);">@微信</div>
					</div>
				</div>
			</div>
			<van-cell-group class="data-group">
				<div
					v-for="(item, index) in detail"
					:key="index"
				>
					<div v-if="item.typeText == '图片'" class="picture-wrapper">
						<span class="title">{{ item.name }}</span>
						<van-uploader
							multiple
							v-model="item.fileList"
							@click="upload(index)"
							@delete="imgChange($event, item)"
							:after-read="afterRead"
							:before-read="beforeRead"
							result-type="file"
							:max-count="1">
						</van-uploader>
					</div>
					<div v-else-if="item.typeText == '单选'" class="check-wrapper">
						<span class="title">{{ item.name }}</span>
						<van-radio-group v-model="item.value" class="check-group" direction="horizontal">
							<van-radio
								v-for="(val, ind) in item.options"
								:key="ind + val"
								:name="val"
								icon-size="15px"
								class="check-item"
							>
								<span class="check-text">{{ val }}</span>
							</van-radio>
						</van-radio-group>
					</div>
					<div v-else-if="item.typeText == '多选'" class="check-wrapper" style="margin-bottom: var(--base-px-5);">
						<span class="title">{{ item.name }}</span>
						<van-checkbox-group v-model="item.value" class="check-group check-group-row" direction="horizontal">
							<van-checkbox
								v-for="(val, ind) in item.options"
								:key="ind + val"
								:name="val"
								icon-size="15px"
								class="check-item"
							>
								<span class="check-text">{{ val }}</span>
							</van-checkbox>
						</van-checkbox-group>
					</div>
					<div v-else-if="item.typeText == '下拉'" class="check-wrapper">
						<span class="title">{{ item.name }}</span>
						<div class="row_option" @click="setOptionCont(item, index)">
							<span class="option-tip" v-if="!item.value">请设置选项</span>
							<span class="option-value" v-else>{{ item.value }}</span>
						</div>
					</div>
					<van-field
						v-else
						:label="item.name"
						:placeholder="`请输入${item.name}`"
						v-model="item.value"/>
				</div>
			</van-cell-group>
			<div style="padding:0 var(--base-px-20) var(--base-px-15) var(--base-px-20);">
				<van-button type="info" block @click="modifyUserBtn">修改</van-button>
			</div>
		</Popup>
		<selectTime ref="selectTime"/>
		<!--    选择弹窗-->
		<setDetailOption ref="setDetailOption" @change="receiveOption"/>
	</div>
</template>
<script>
// eslint-disable-next-line no-unused-vars
import {ContactApi} from '@/api/contact'
import {Popup, Divider, DatetimePicker, Toast} from 'vant'
import selectTime from '../../room/components/selectTime'
import setDetailOption from './setDetailOption'

export default {
	components: {
		Popup, Divider, DatetimePicker, selectTime, setDetailOption
	},
	data() {
		return {
			userDetail: false,
			userName: '',
			avatar: '',
			detail: [],
			checkRowIndex: ''
		}
	},
	methods: {
		receiveOption(e) {
			this.detail[this.checkRowIndex].value = e
		},
		// 弹窗选项
		setOptionCont(item, index) {
			this.checkRowIndex = index
			this.$refs.setDetailOption.show(item)
		},
		modifyUserBtn() {
			this.detail.map(item => {
				if (item.typeText == '多选') {
					item.value = item.value.filter(inner => {
						return inner
					})
				}
			})
			ContactApi.updateContactPortrait({
				contactId: this.contactId,
				userPortrait: JSON.stringify(this.detail)
			}).then(res => {
				Toast('修改成功')
				this.userDetail = false
				this.$emit('change', true)
			})
		},
		show(contactDetailInfo) {
			this.userDetail = true
			this.contactId = contactDetailInfo.contactId
			this.userName = contactDetailInfo.name
			this.avatar = contactDetailInfo.avatar
			this.getDetail()
		},
		//  用户详情
		getDetail() {
			ContactApi.getContactPortrait({contactId: this.contactId}).then((res) => {
				this.detail = res.data.map(item => {
					if (item.typeText == '图片') {
						if (item.pictureFlag) {
							item.fileList = [{
								url: item.pictureFlag
							}]
						}
					} else if (item.typeText == '下拉') {
						item.selectOptions = item.options.map(item => {
							return {
								value: item,
								text: item
							}
						})
					}
					return item
				})
			})
		}
	}
}
</script>
<style lang="less" scoped>
.user_page {
	padding: 0 var(--base-px-35) 0 var(--base-px-35);
	color: #333;
}

.user_flex {
	display: flex;
	justify-content: space-between;
}

.data-group {
	padding: var(--base-px-10) 0 var(--base-px-30) 0
}

.picture-wrapper, .check-wrapper {
	align-items: center;
	display: flex;
	padding: 0 var(--base-px-16);

	.title {
		max-width: var(--base-px-400);
		min-width: var(--base-px-100);
		font-weight: 400;
		color: #919191;
	}

	.check-text {
		font-weight: 400;
		line-height: var(--base-px-50);
	}

	.picture {
		width: var(--base-px-128);
		height: var(--base-px-128);
		margin-left: var(--base-px-20);
	}

	.check-group {
		margin-left: var(--base-px-20);

		.check-item {
			margin-left: var(--base-px-10);
		}
	}

	.check-group-row {
	}

	.dropdown-menu {
		display: flex;
		flex: 1;
		align-items: center;
		margin-left: var(--base-px--20);
		height: var(--base-px-80);
	}
}

.upload {
	color: #1989fa;
}

.row_option {
	margin-left: var(--base-px-32);
	width:  var(--base-px-270);
	height: var(--base-px-35);
	border: var(--base-px-1) solid #cccccc;
	//line-height: var(--base-px-55);
	display: flex;
	align-items: center;
	padding-left: var(--base-px-15);
	border-radius: var(--base-px-5);
	cursor: pointer;
}

.option-tip {
	color: #919191;
}

.option-value {

}
</style>
